module.exports = __webpack_public_path__ + "img/rcyc-zcnr.c02e96d6.png";